import type { Mixpanel } from 'mixpanel-browser';

export const MIX_PANEL: {
  /**
   * Mixpanel instance for tracking meta-box events
   */
  metaBoxTrack?: Mixpanel;

  /**
   * Mixpanel instance for tracking stream events
   */
  streamTrack?: Mixpanel;
} = {
  metaBoxTrack: undefined,
  streamTrack: undefined,
};

export const MixPanelEvents = {
  pixelstreaming_end: 'pixelstreaming_end',
  pixelstreaming_start: 'pixelstreaming_start',
  render_request: 'render_request',
  custom_click: 'custom_click',
  route_change: 'route_change',
} as const;

export type MixPanelEventsKeys =
  (typeof MixPanelEvents)[keyof typeof MixPanelEvents];
